import React, { useContext, useRef, useEffect, useState } from 'react'

import './CalculatorError.scss';
import { CalculatorResultsContext } from '../Store/CalculatorResultsContext';
import { fold, isSome, none } from 'fp-ts/lib/Option';
import { pipe } from 'fp-ts/lib/pipeable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { CalculatorStepsContext } from '../Store/CalculatorStepsContext';


export const CalculatorServiceError = () => {
    const resultsStore = useContext(CalculatorResultsContext);
    const stepStore = useContext(CalculatorStepsContext);
    const errorFocus = useRef<HTMLParagraphElement>(null)
    const [errorString, setErrorString] = useState("");

    const ESCAPE_KEY = "Escape";
    const ENTER_KEY = "Enter";

    useEffect(() => {
        pipe(resultsStore.error,
            fold(() => { return; },
                (err) => {
                    console.log("API Service error: " + err);
                    setErrorString(err);
                    if (errorFocus.current !== null) {
                        errorFocus.current.focus();
                    }
                }

            ));
    }, [resultsStore.error]);

    const hasServiceError = isSome(resultsStore.error);
    const [hasSetupError, setHasSetupError] = useState(false);

    useEffect(() => {
        const config = stepStore.steps.config;
        const configLoaded = config.availableInvestmentStrategies.strategies.length > 0;
        if(configLoaded){            
            setHasSetupError(config.calculatorUrl === null);
            setErrorString('The calculator is not available at the moment. Please try again later.');
        }
    }, [stepStore.steps.config]);

    const warningIconMedium = (<FontAwesomeIcon
        data-testid="fa-exclamation-triangle-icon"
        size="2x"
        color="#c75a00"
        icon={faExclamationTriangle}
    />);

    const errorModalClass = "calculator-error-modal";

    const classNames = (hasServiceError || hasSetupError)
        ? [errorModalClass, "visible"].join(' ')
        : [errorModalClass, "invisible"].join(' ')

    function clearError() {
        resultsStore.setError(none);
    }

    function handleKeyDown(keyEvt: React.KeyboardEvent<HTMLDivElement>) {
        if (keyEvt.key === ESCAPE_KEY) {
            clearError();
        }
    }

    function handleCloseIconEnterKey(keyEvt: React.KeyboardEvent<HTMLDivElement>) {
        if (keyEvt.key === ENTER_KEY) {
            clearError();
        }
    }

    return (<div id="rila-calculator-error-modal" className={classNames} tabIndex={0} onKeyDown={handleKeyDown}>
        <div className="error-display">
            {hasServiceError
                ? resultsStore.hasResults()
                    ? (<div className="calculator-service-update-error" ref={errorFocus} tabIndex={0} role="alert">
                        <div className="icon">{warningIconMedium}</div>
                        <div id="rila-close-error-dialog-icon" className="close close-error-dialog" onClick={clearError} tabIndex={0} onKeyDown={handleCloseIconEnterKey}> <span className="sr-only">Close</span></div>
                        <div className="message">Sorry - we&#8217;re unable to show you custom scenarios right now. Please try again later.</div>
                    </div>)
                    : (<div className="calculator-service-error" ref={errorFocus} tabIndex={0} role="alert">
                        <div className="icon">{warningIconMedium}</div>
                        <h2 className="headline">Calculator Unavailable</h2>
                        <div id="rila-close-error-dialog-icon" className="close close-error-dialog" onClick={clearError} tabIndex={0} onKeyDown={handleCloseIconEnterKey}> <span className="sr-only">Close</span></div>
                        <div className="message">{errorString}</div>
                    </div>)
                : null}
                {
                    hasSetupError && (<div className="calculator-service-error" ref={errorFocus} tabIndex={0} role="alert">
                    <div className="icon">{warningIconMedium}</div>
                    <h2 className="headline">Error:</h2>
                    <div className="message">{errorString}</div>
                </div>)
                }
        </div>
    </div>);
}
